module.exports = __webpack_public_path__ + "img/login_logo.6467d188.png";